
const isOwner = (project: any, profileId?: string) => {
    if (!project) return undefined
    return profileId ? (project?.authorId === profileId || project?.coAuthorIds?.includes(profileId)) : false
}

export const checkIsLongreadAndTeamOwner = (project: any, profileId?: string) => {
    if (!project && !project?.teams) return false;
    if (project?.teams?.length === 0) return false;
    return project?.teams?.[0]?.ownersIDs?.includes(profileId) && isOwner(project, profileId);
}
const isOwner = (project: any, profileId?: string) => {
    if (!project) return undefined
    return profileId ? (project?.authorId === profileId || project?.coAuthorIds?.includes(profileId)) : false
}

export const checkIsLongreadAndTeamOwner = (project: any, profileId?: string) => {
    if (!project && !project?.teams) return false;
    if (project?.teams?.length === 0) return false;
    return project?.teams?.[0]?.ownersIDs?.includes(profileId) && isOwner(project, profileId);
}